import React, { useState } from "react";
import RadioButton from "../../../generic/radioButton";
import EdButton from "../../../generic/edButton";
import Loader from "../../../generic/loader";
import "../../../../assets/scss/components/toc/orderBook/obConvertPositions/obProductTypeSelectDesk.scss";
import "../../../../assets/scss/components/toc/orderBook/obConvertPositions/obProductTypeSelectMob.scss";
import DeviceContext from "../../../service/indentifyDevice";
import { IListObj } from "../../../types/genericTypes";

export interface IObProductTypeSelectProps {
	list: Array<IListObj>; // list of all options
	numOfQty: number; // number of quantities selected
	onConvertPosition: (selectedRadio: string) => void;
	isProcessing: boolean;
	onClose?: () => void;
}

const ObProductTypeSelect: React.FC<IObProductTypeSelectProps> = (props: IObProductTypeSelectProps) => {
	const defaultBtnTxt = DeviceContext().isMobile ? "Convert" : "Convert Positions";
	const [selectedRadio, setSelectedRadio] = useState<string>();
	// const [btnText, setBtnText] = useState(defaultBtnTxt as string | React.ReactElement);
	const processingBtn = (
		<span className="processing_btn">
			Processing
			<Loader size={20} />
		</span>
	);

	function onConvertPosition(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		event.preventDefault();
		// setBtnText(
		// 	<span className="processing_btn">
		// 		Processing
		// 		<Loader size={20} />
		// 	</span>
		// );
		props.onConvertPosition(selectedRadio!);
	}

	function onClose(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		event.preventDefault();
		props.onClose && props.onClose();
	}

	return (
		<form className="ob_convert_positions_desktop">
			<h2 className="heading">Select Product Type</h2>
			<ul className="list">
				{props.list.map((item: any) => (
					<li key={item.value} className="list_Item" onClick={() => setSelectedRadio(item.value)}>
						<RadioButton
							list={{
								value: item.value,
								display: item.display
							}}
							name={"cvtPosition"}
							selected={selectedRadio}
							onChange={() => setSelectedRadio(item.value)}
						/>
					</li>
				))}
			</ul>
			<div className="total">
				<p className="total_heading">Total</p>
				<p className="total_value">
					{props.numOfQty} Qty
					{selectedRadio && " to " + props.list.find((e) => e.value === selectedRadio)?.display}
				</p>
			</div>
			{DeviceContext().isMobile && (
				<EdButton value="Close" btnTyp="secondary" onClick={onClose} className="cvt_position_btn" disabled={props.isProcessing} />
			)}
			<EdButton
				value={props.isProcessing ? processingBtn : defaultBtnTxt}
				btnTyp="primary"
				type="submit"
				onClick={onConvertPosition}
				className="cvt_position_btn"
				disabled={props.numOfQty === 0 || !selectedRadio || props.isProcessing}
			/>
		</form>
	);
};

export default ObProductTypeSelect;
